import Icon from '../components/Icon.vue'

Icon.register({
  swimmer: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M189.6 310.6c-5-4.7-10.4-8.3-15.9-11.6l68.6-98c7.4-10.5 16.3-19.5 26.7-26.9l80-57.2c25.5-18.3 57.8-25 88.6-18.4l100.4 21.5c25.9 5.6 42.4 31.1 36.9 57-5.6 25.9-31.1 42.4-57 36.9l-100.4-21.5c-4.3-0.9-9 0-12.6 2.6l-18 12.9 112.8 80.6c-17.5 1-34.5 8.5-49.4 22.2-3.5 3.3-15.3 9.4-34.4 9.4s-30.8-6.2-34.4-9.4c-16-14.8-34.5-22.6-53.5-22.6h-16.3c-19 0-37.4 7.8-53.5 22.6-3.5 3.3-15.3 9.4-34.4 9.4s-30.8-6.2-34.4-9.4zM624 352c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-16c-38.6 0-72.7-12.2-96-31.8-23.3 19.6-57.4 31.8-96 31.8s-72.7-12.2-96-31.8c-23.3 19.6-57.4 31.8-96 31.8s-72.7-12.2-96-31.8c-23.3 19.6-57.4 31.8-96 31.8h-16c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h16c26 0 45.8-8.4 56.1-17.9 8.9-8.2 19.7-14.1 31.8-14.1h16.3c12.1 0 22.9 5.9 31.8 14.1 10.3 9.5 30 17.9 56.1 17.9s45.8-8.4 56.1-17.9c8.9-8.2 19.7-14.1 31.8-14.1h16.3c12.1 0 22.9 5.9 31.8 14.1 10.3 9.5 30 17.9 56.1 17.9s45.8-8.4 56.1-17.9c8.9-8.2 19.7-14.1 31.8-14.1h16.3c12.1 0 22.9 5.9 31.8 14.1 10.3 9.5 30 17.9 56.1 17.9h16zM112 256c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/swimmer.js
// module id = 1971
// module chunks = 0